import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Regist from '@/views/Regist'
import ModifyPassword from '@/views/modifypassword'
import Container from '@/container/Container'
import RepairContainer from '@/container/RepairContainer'
import AdminContainer from '@/container/AdminContainer'
import AdminRepairContainer from '@/container/AdminRepairContainer'
import Home from '@/views/Home'
import RepairHome from '@/views/Repair/Home'
import MobileLogin from '@/mobile/Login'
import MobileRegist from '@/mobile/regist'
import MobileHome from '@/mobile/home'
import RepairMobileHome from '@/mobile/repairhome'
import MobileDevice from '@/mobile/devicelist'
import MobileModifyPassword from '@/mobile/modifypassword'
import AdminLogin from '@/admin/Login'
import AdminHome from '@/admin/Home'
import ImportDevice from '@/admin/ImportDevice'
import ExportDevice from '@/admin/ExportDevice'
import AdminDevice from '@/admin/AdminDevice'
import AdminUser from '@/admin/AdminUser'
import User from '@/admin/User'
import BarcodeSort from '@/admin/BarcodeSort'
import AdminModifyPassword from '@/admin/modifypassword'
import PType from '@/admin/PType'
import DType from '@/admin/DType'
import DClassify from '@/admin/DClassify'
import DModel from '@/admin/DModel'

import AdminRepairHome from '@/admin/Repair/RepairHome'
import RepairShop from '@/admin/Repair/RepairShop'
import RepairShopType from '@/admin/Repair/RepairShopType'
import RepairDModel from '@/admin/Repair/RepairDmodel'
import RepairDClassify from '@/admin/Repair/RepairDclassify'
import ExportRepair from '@/admin/Repair/ExportRepair'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/regist',
      name: 'Regist',
      component: Regist
    },
    {
      path: '/mobile/login',
      name: 'MobileLogin',
      component: MobileLogin
    },
    {
      path: '/mobile/regist',
      name: 'MobileRegist',
      component: MobileRegist
    },
    {
      path: '/mobile',
      redirect: '/mobile/home',
      name: 'MobileHome',
      component: MobileHome,
      children: [{ path: 'home', name: '首页', component: MobileHome }]
    },
    {
      path: '/mobile',
      redirect: '/mobile/repairhome',
      name: 'RepairtMobileHome',
      component: RepairMobileHome,
      children: [
        { path: 'repairhome', name: '首页', component: RepairMobileHome }
      ]
    },
    {
      path: '/mobile/device',
      name: 'mobileDevice',
      component: MobileDevice
    },
    {
      path: '/mobile/modifypassword',
      name: 'MobileModifyPassword',
      component: MobileModifyPassword
    },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admin',
      redirect: '/admin/home',
      name: 'AdminContainer',
      component: AdminContainer,
      children: [
        { path: 'home', name: '首页', component: AdminHome },
        { path: 'importdevice', name: '发货数据导入', component: ImportDevice },
        { path: 'exportdevice', name: '注册信息导出', component: ExportDevice },
        { path: 'admindevice', name: '发货数据管理', component: AdminDevice },
        { path: 'adminuser', name: '后台用户', component: AdminUser },
        { path: 'user', name: '保修用户', component: User },
        { path: 'barcodesort', name: '条码顺序', component: BarcodeSort },
        { path: 'ptype', name: '产品类别', component: PType },
        { path: 'dtype', name: '设备种类', component: DType },
        { path: 'dclassify', name: '设备分类', component: DClassify },
        { path: 'dmodel', name: '设备型号', component: DModel },
        {
          path: 'modifypassword',
          name: '修改密码',
          component: AdminModifyPassword
        }
      ]
    },
    {
      path: '/admin/repair',
      redirect: '/admin/repair/home',
      name: 'AdminRepairContainer',
      component: AdminRepairContainer,
      children: [
        { path: 'home', name: '首页', component: AdminRepairHome },
        { path: 'exportrepair', name: '首页', component: ExportRepair },
        { path: 'adminuser', name: '后台用户', component: AdminUser },

        { path: 'user', name: '保修用户', component: User },
        {
          path: 'repairdclassify',
          name: '设备分类',
          component: RepairDClassify
        },
        { path: 'repairdmodel', name: '设备型号', component: RepairDModel },
        {
          path: 'repairshop',
          name: '维修店',
          component: RepairShop
        },
        {
          path: 'repairshoptype',
          name: '维修店类别',
          component: RepairShopType
        },
        {
          path: 'modifypassword',
          name: '修改密码',
          component: AdminModifyPassword
        }
      ]
    },
    {
      path: '/',
      redirect: '/home',
      name: 'Container',
      component: Container,
      children: [{ path: 'home', name: '首页', component: Home }]
    },
    {
      path: '/ModifyPassword',
      name: 'ModifyPassword',
      component: ModifyPassword
    },
    {
      path: '/repair',
      redirect: '/Repair/home',
      name: 'RepairContainer',
      component: RepairContainer,
      children: [{ path: 'home', name: '首页', component: RepairHome }]
    },
    {
      path: '/ModifyPassword',
      name: 'ModifyPassword',
      component: ModifyPassword
    }
  ],
  mode: 'history' // 去除#号
})
// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('mobile') > 0) {
    if (to.path === '/mobile/login') {
      sessionStorage.removeItem('user')
    }
    var muser = sessionStorage.getItem('user')

    if (!muser && to.path !== '/mobile/login' && to.path !== '/mobile/regist') {
      next({
        path: '/mobile/login'
      })
    } else {
      next()
    }
  } else if (to.path.indexOf('admin') > 0) {
    if (to.path === '/admin/login') {
      sessionStorage.removeItem('adminuser')
    }
    var adminuser = sessionStorage.getItem('adminuser')

    if (!adminuser && to.path !== '/admin/login') {
      next({
        path: '/admin/login'
      })
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      sessionStorage.removeItem('user')
    }
    var user = sessionStorage.getItem('user')

    if (!user && to.path !== '/login' && to.path !== '/regist') {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
})

export default router

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}



// WEBPACK FOOTER //
// ./src/router/index.js